let UTILS = require("../libs/utils.js");
var vA385 = [{
  p: [33, 1, 171],
  s: [1.3, 7.21, 7.45],
  i: 55,
  h: 200,
  cdy: 1,
  tm: 2,
  tAi: 1,
  ct: 1,
  te: 15,
  mro: 270,
  tas: [{
    ta: 60,
    tct: "4280|0.1,4041|0.1,5728|0.1,3238|0.25"
  }],
  rsc: 50,
  sd: 1,
  ms: 1.4,
  aid: "46802q",
  rmt: 5000,
  rmr: 60,
  aic: 10,
  tsd: 1,
  spd: 0.8,
  prs: 1,
  prg: 0,
  prsc: 1,
  prms: 1,
  pjs: 1,
  pjd: 100,
  vd: 10000,
  idl: 32601,
  dth: 0,
  atk: 0,
  atkh: 0,
  mel: 32600,
  melh: 0,
  agr: 0,
  fr: 2000,
  aac: 0,
  shb: 400,
  sha: 0,
  shdy: 0,
  mldy: 300,
  mls: 0,
  ss: 0,
  crd: 1.5,
  crh: 2.8,
  hr: 1000,
  mlr: 15,
  mlra: 1.5,
  mld: 40,
  grv: 1,
  bh: 0,
  pht: 0,
  phi: "",
  cnh: 1,
  xv: 1,
  ain: "Walker",
  ains: 1,
  hbh: 2.7,
  hbw: 0.9,
  ail: 10,
  sp: 25,
  as: 0.8,
  sor: 0.8,
  pmv: 1,
  dos: 1
}, {
  p: [33, 1, 171],
  s: [1.6900000000000002, 9.373000000000001, 9.685],
  i: 55,
  h: 550,
  cdy: 1,
  tm: 2,
  tAi: 1,
  ct: 1,
  te: 15,
  mro: 270,
  tas: [{
    ta: 60,
    tct: "4280|0.1,4041|0.1,5728|0.1,3238|0.25"
  }],
  rsc: 50,
  sd: 1,
  ms: 1.8199999999999998,
  aid: "46802q",
  rmt: 5000,
  rmr: 60,
  aic: 10,
  tsd: 1,
  spd: 0.35,
  prs: 1,
  prg: 0,
  prsc: 1,
  prms: 1,
  pjs: 1,
  pjd: 100,
  vd: 10000,
  idl: 32601,
  dth: 0,
  atk: 0,
  atkh: 0,
  mel: 32600,
  melh: 0,
  agr: 0,
  fr: 2000,
  aac: 0,
  shb: 400,
  sha: 0,
  shdy: 0,
  mldy: 500,
  mls: 0,
  ss: 0,
  crd: 1.5,
  crh: 3.1,
  hr: 1100,
  mlr: 20,
  mlra: 1.5,
  mld: 60,
  grv: 1,
  bh: 0,
  pht: 0,
  phi: "",
  cnh: 1,
  xv: 1,
  ain: "Brute",
  ains: 1,
  hbh: 2.7,
  hbw: 0.9,
  ail: 30,
  sp: 35,
  as: 0.6,
  sor: 0.6,
  pmv: 1,
  dos: 1
}, {
  p: [33, 1, 171],
  s: [1.95, 10.815, 11.175],
  i: 55,
  h: 2500,
  cdy: 1,
  tm: 2,
  tAi: 1,
  ct: 1,
  te: 15,
  mro: 270,
  tas: [{
    ta: 60,
    tct: "4280|0.5,4041|0.5,5728|0.5,3238|1,5819|0.1"
  }],
  rsc: 50,
  sd: 1,
  ms: 1.8,
  aid: "46803q",
  rmt: 5000,
  rmr: 60,
  aic: 10,
  tsd: 0.4,
  spd: 0.35,
  prs: 1,
  prg: 0,
  prsc: 1,
  prms: 1,
  pjs: 1,
  pjd: 100,
  vd: 10000,
  idl: 32601,
  dth: 0,
  atk: 0,
  atkh: 0,
  mel: 32600,
  melh: 0,
  agr: 0,
  fr: 2000,
  aac: 0,
  shb: 400,
  sha: 0,
  shdy: 0,
  mldy: 700,
  mls: 0.1,
  ss: 0,
  crd: 1.5,
  crh: 4.9,
  hr: 1500,
  mlr: 30,
  mlra: Math.PI,
  mld: 100,
  grv: 1,
  bh: 0,
  pht: 0,
  phi: "",
  cnh: 1,
  xv: 1,
  ain: "Flesh Colossal",
  ains: 1.5,
  hbh: 3.5,
  hbw: 1.8,
  ail: 70,
  sp: 150,
  as: 1,
  sor: 0.35,
  pmv: 1,
  dos: 1
}, {
  p: [33, 1, 171],
  s: [1.3, 7.21, 7.45],
  i: 55,
  h: 200,
  cdy: 1,
  tm: 2,
  tAi: 1,
  ct: 1,
  te: 15,
  mro: 270,
  tas: [{
    ta: 60,
    tct: "4280|0.25,4041|0.25,5728|0.25,3238|0.5"
  }],
  rsc: 50,
  sd: 1,
  ms: 1.4,
  aid: "46804q",
  rmt: 5000,
  rmr: 60,
  aic: 10,
  tsd: 1.8,
  spd: 1.4,
  prs: 1,
  prg: 0,
  prsc: 1,
  prms: 1,
  pjs: 1,
  pjd: 100,
  vd: 10000,
  idl: 32601,
  dth: 0,
  atk: 0,
  atkh: 0,
  mel: 32600,
  melh: 0,
  agr: 0,
  fr: 2000,
  aac: 0,
  shb: 400,
  sha: 0,
  shdy: 0,
  mldy: 300,
  mls: 0,
  ss: 0,
  crd: 1.5,
  crh: 2.1,
  hr: 1000,
  mlr: 15,
  mlra: 1.5,
  mld: 30,
  grv: 1,
  bh: 0,
  pht: 0,
  phi: "",
  cnh: 1,
  xv: 1,
  ain: "Runner",
  ains: 1,
  hbh: 2.5,
  hbw: 1,
  ail: 10,
  sp: 25,
  as: 0.8,
  sor: 1,
  pmv: 1,
  dos: 1
}, {
  p: [33, 1, 171],
  s: [1.3, 7.21, 7.45],
  i: 55,
  h: 200,
  cdy: 1,
  tm: 2,
  tAi: 1,
  ct: 1,
  te: 15,
  mro: 270,
  tas: [{
    ta: 60,
    tct: "4280|0.1,4041|0.1,5728|0.1,3238|0.25"
  }],
  rsc: 50,
  sd: 1,
  ms: 0.5,
  aid: "46803q",
  rmt: 5000,
  rmr: 60,
  aic: 10,
  tsd: 3.6,
  spd: 1.4,
  prs: 1,
  prg: 0,
  prsc: 1,
  prms: 1,
  pjs: 1,
  pjd: 100,
  vd: 10000,
  idl: 32601,
  dth: 0,
  atk: 0,
  atkh: 0,
  mel: 32600,
  melh: 0,
  agr: 0,
  fr: 2000,
  aac: 0,
  shb: 400,
  sha: 0,
  shdy: 0,
  mldy: 300,
  mls: 0,
  ss: 0,
  crd: 1.5,
  crh: 2.1,
  hr: 1000,
  mlr: 15,
  mlra: 1.5,
  mld: 30,
  grv: 1,
  bh: 0,
  pht: 0,
  phi: "",
  cnh: 1,
  xv: 1,
  ain: "Rascal",
  ains: 1,
  hbh: 2.5,
  hbw: 1,
  ail: 1,
  sp: 25,
  as: 0.8,
  sor: 1,
  pmv: 1,
  dos: 1
}];
var vLN1510 = 15;
const vF51 = () => ({
  concZomb: 5,
  zombCnts: [10, 0, 0, 1],
  tmpCnts: [],
  hpMlt: 1,
  dmgMlt: 1,
  spdMlt: 1,
  zLeft: 0
});
var v7786;
var v7787;
var vA386 = [{
  name: "FRENZY",
  zombCnts: [0, 2, 0, 10]
}, {
  name: "ONSLAUGHT",
  zombCnts: [0, 15, 1, 1]
}, {
  name: "DEVASTATION",
  zombCnts: [2, 2, 5, 5]
}, {
  name: "ANNIHILATION",
  zombCnts: [5, 5, 10, 5]
}, {
  name: "LIMBO",
  zombCnts: [0, 0, 15, 10]
}];
module.exports = {
  id: "zom",
  name: "Zombies",
  alias: "zom",
  noSliding: true,
  noStreaks: true,
  noWallJ: true,
  impulseMlt: 0,
  lives: 1,
  endStats: ["sid", "name", "score", "zombies", "downs", "rounds", "reward"],
  leaderStats: ["points", "zombies", "downs", "dmg"],
  description: "Survive endless waves of zombies",
  descriptionLang: "game.mode.zom.description",
  sendR: 5,
  lives: 1,
  minPlayers: 1,
  skipStats: ["h", "s", "crc", "step"],
  friendly: true,
  viewDis: 500,
  noClassScr: true,
  forceClass: 9,
  finiteAmmo: true,
  startingLoadout: [2],
  noScrLimit: true,
  unrestrictedWeapons: true,
  pointsPerHit: 0.085,
  starterScore: 150,
  gameTime: 0,
  regenMlt: 0.1,
  forceOldScoreboard: true,
  preventCustomGames: true,
  forceCharge: true,
  showAllLeaders: true,
  noMinimap: true,
  winCondition: function () {
    return 2;
  },
  condition: [function (game) {
    var vLN01252 = 0;
    for (var vLN01253 = 0; vLN01253 < game.players.list.length; ++vLN01253) {
      if (game.players.list[vLN01253].lives > 0 && game.players.list[vLN01253].active) {
        vLN01252++;
      }
    }
    return vLN01252 > 0;
  }],
  gameStart: function (p9319) {
    p9319.zombieSpawnTim = 0;
    p9319.skipZCheck = false;
    p9319.zWave = 0;
    p9319.zWaveData = vF51();
    p9319.zSpawnPoints = p9319.map.manager.serverNodes ? p9319.map.manager.serverNodes.filter(p9320 => p9320 && p9320.tag == "zombie_spawn") : [];
    p9319.zFrogSpawnRound = UTILS.randInt(4, 7);
    p9319.zDroneSpawnRound = UTILS.randInt(9, 13);
    p9319.eePAPCompleted = false;
    p9319.eePAPActive = false;
    p9319.eePAPOrder = ["Walker", "Brute", "Runner"];
    UTILS.yateShuffle(p9319.eePAPOrder);
    p9319.eePAPProgress = 0;
    p9319.eeDanceTimer = 0;
    p9319.eeDanceCompleted = false;
    p9319.eeDanceSkullSpawns = p9319.map.manager.serverNodes ? p9319.map.manager.serverNodes.filter(p9321 => p9321 && p9321.tag == "skull_spawn") : [];
    p9319.eeDanceSkulls = 0;
  },
  onPreEnd: function (game) {
    if (game.bots && game.bots.list) {
      for (var vLN01254 = game.bots.list.length - 1; vLN01254 >= 0; --vLN01254) {
        game.bots.remove(game.bots.list[vLN01254]);
      }
    }
    var v7789;
    for (var vLN01254 = 0; vLN01254 < game.players.list.length; ++vLN01254) {
      v7789 = game.players.list[vLN01254];
      game.challenges.update(game, "rnd", v7789.rounds || 0, null, v7789);
      v7789.score = (game.zWave || 1) * 100;
    }
  },
  onEnd: function (game, p9324, p9325) {
    if (!(game.zWave <= 1) && game.isPubType()) {
      var v7790;
      for (var vLN01255 = 0; vLN01255 < game.players.list.length; ++vLN01255) {
        v7790 = game.players.list[vLN01255];
        if (v7790 && v7790.account) {
          p9325.call(135, [4, v7790.account.id, game.zWave], function () {});
        }
      }
    }
  },
  onKill: function (game, p9327, p9328) {
    for (var vLN01256 = 0; vLN01256 < game.players.list.length; ++vLN01256) {
      if ((game.players.list[vLN01256].active && !game.players.list[vLN01256].spectating || p9328 == game.players.list[vLN01256]) && !(game.players.list[vLN01256].score <= 0)) {
        var v7791 = Math.floor(game.players.list[vLN01256].score * 0.1);
        if (v7791 > 0) {
          game.players.score(game.players.list[vLN01256], -v7791);
        }
      }
    }
  },
  powerupRarities: [89, 5, 4, 2],
  powerups: [[], [9, 14], [11, 15], [10, 12, 13]],
  onAIDeath: function (game, p9330, p9331) {
    if (game.zWave && game.zWave % 5 == 0 && game.zWaveData.zLeft <= 0 && game.activeAIs(2) <= 0) {
      game.dropSpawnable(9, p9330, null, {
        x: p9330.x,
        y: p9330.y,
        z: p9330.z
      });
    }
    if (p9331 && p9331.isPlayer) {
      var v7792 = UTILS.randFloat(0, 100).round(2);
      if (this.powerupRarities[0] == 0) {
        v7792 = Math.max(v7792, 0.01);
      }
      var v7793;
      var vLN01257 = 0;
      var vLN01258 = 0;
      for (var vLN01259 = 0; vLN01259 < this.powerupRarities.length; ++vLN01259) {
        v7793 = this.powerupRarities[vLN01259];
        vLN01258 += v7793;
        if (v7792 <= vLN01258) {
          vLN01257 = vLN01259;
          break;
        }
      }
      if (this.powerups[vLN01257 || 0].length) {
        var v7794 = UTILS.getRandom(this.powerups[vLN01257 || 0]);
        game.dropSpawnable(v7794, p9330, null, {
          x: p9330.x,
          y: p9330.y,
          z: p9330.z
        });
      }
      var v7795 = UTILS.randFloat(0, 100);
      if (v7795 >= 99) {
        game.dropSpawnable(19, p9330, null, {
          x: p9330.x,
          y: p9330.y,
          z: p9330.z
        });
      }
      var v7796 = p9331.loadout[p9331.loadoutIndex];
      game.challenges.update(game, "aik", 1, {
        wep: v7796
      }, p9331);
    }
  },
  onTrigger: function (game) {
    if (!game.eePAPActive) {
      game.eePAPActive = true;
      var v7797 = game.map.manager.serverNodes.find(p9333 => p9333 && p9333.tag == "portal_spawn");
      if (v7797) {
        game.dropSpawnable(20, null, null, {
          x: v7797.x,
          y: v7797.y,
          z: v7797.z
        });
      }
    }
  },
  update: function (game, p9335, p9336) {
    if (!game.waitTimers || game.waitTimers[0] && game.waitTimers[0].contTime) {
      if (!game.zSpawnPoints || !game.zSpawnPoints.length) {
        return;
      }
      if (game.eeDanceTimer) {
        game.eeDanceTimer -= p9336;
        if (game.eeDanceTimer <= 0) {
          game.eeDanceTimer = 0;
          if (!game.eeDanceCompleted) {
            game.broadcast("tx", "Souls escaped", "", true);
          }
        }
      }
      game.zombieSpawnTim -= p9336;
      if (game.zombieSpawnTim <= 0) {
        game.zombieSpawnTim = 10000;
        var v7798 = game.activeAIs(2);
        if (v7798 <= 0 && game.zWaveData.zLeft <= 0 && !game.skipZCheck) {
          game.zWave++;
          game.skipZCheck = true;
          game.zombieSpawnTim = 7500;
          game.checkPlayerLimit();
          for (var vLN01263 = 0; vLN01263 < game.players.list.length; ++vLN01263) {
            game.players.list[vLN01263].rounds = (game.players.list[vLN01263].rounds || 0) + 1;
            if ((!game.players.list[vLN01263].active || !!game.players.list[vLN01263].spectating) && !game.players.list[vLN01263].kpdData) {
              game.players.list[vLN01263].lives = 1;
              game.players.list[vLN01263].send("frs", true);
              game.players.score(game.players.list[vLN01263], Math.round(game.players.list[vLN01263].score * 0.5), undefined, true);
            }
          }
          if (game.zWave && game.zWave % game.zDroneSpawnRound == 0) {
            var v7801 = UTILS.randFloat(0, 100);
            if (v7801 >= 99.99) {
              var v7800 = UTILS.getRandom(game.players.list.filter(p9337 => p9337 && p9337.account));
              if (v7800) {
                game.giveSkin(v7800, 5837, "zombies");
              }
            }
          }
          if (game.zWave && game.zWave % game.zFrogSpawnRound == 0) {
            var v7801 = UTILS.randFloat(0, 100);
            if (v7801 >= 80) {
              var v7802 = UTILS.getRandom(game.map.manager.serverNodes.filter(p9338 => p9338 && p9338.tag == "frog_spawn"));
              if (v7802) {
                game.dropSpawnable(17, null, null, {
                  x: v7802.x,
                  y: v7802.y,
                  z: v7802.z
                });
              }
            }
          }
          game.zWaveData.concZomb += 2;
          game.zWaveData.concZomb = Math.min(game.zWaveData.concZomb, 30);
          game.zWaveData.zombCnts[0] += game.zWave % 2 == 0 ? 1 : 0;
          game.zWaveData.zombCnts[0] = Math.min(game.zWaveData.zombCnts[0], 30);
          game.zWaveData.zombCnts[1] += game.zWave % 2 == 0 ? 1 : 0;
          game.zWaveData.zombCnts[1] = Math.min(game.zWaveData.zombCnts[1], 10);
          game.zWaveData.zombCnts[2] += game.zWave % 4 == 0 ? 1 : 0;
          game.zWaveData.zombCnts[2] = Math.min(game.zWaveData.zombCnts[2], 5);
          game.zWaveData.zombCnts[3] += game.zWave % 3 == 0 ? 1 : 0;
          game.zWaveData.zombCnts[3] = Math.min(game.zWaveData.zombCnts[2], 4);
          var v7803 = game.zWave % 5 == 0 ? UTILS.getRandom(vA386) : undefined;
          game.zWaveData.tmpCnts.length = 0;
          game.zWaveData.zLeft = 0;
          for (var v7804 = v7803 ? v7803.zombCnts : game.zWaveData.zombCnts, vLN01263 = 0; vLN01263 < v7804.length; ++vLN01263) {
            game.zWaveData.zLeft += parseInt(v7804[vLN01263]);
            for (var vLN01262 = 0; vLN01262 < v7804[vLN01263]; ++vLN01262) {
              game.zWaveData.tmpCnts.push(vLN01263);
            }
          }
          game.zWaveData.hpMlt += game.zWave % 2 == 0 ? 0.1 : 0;
          game.zWaveData.dmgMlt += game.zWave % 4 == 0 ? 0.1 : 0;
          game.zWaveData.spdMlt += game.zWave % 4 == 0 ? 0.1 : 0;
          game.broadcast("upz", game.zWave, v7803 ? v7803.name : null);
          return;
        }
        game.skipZCheck = false;
        for (var v7805 = game.zWaveData, v7806 = v7805.concZomb - v7798, vLN01263 = 0; vLN01263 < v7806 && !!v7805.tmpCnts.length; ++vLN01263) {
          var v7807 = v7805.tmpCnts.splice(UTILS.randInt(0, v7805.tmpCnts.length - 1), 1)[0];
          var v7808 = UTILS.getRandom(game.zSpawnPoints);
          var v7809 = vA385[v7807];
          var vO221 = {
            ...v7809
          };
          vO221.h = Math.round(v7809.h * v7805.hpMlt);
          vO221.mld = Math.round(v7809.mld * v7805.dmgMlt);
          vO221.spd = v7809.spd * v7805.spdMlt;
          if (!game.eePAPCompleted) {
            vO221.ail = parseInt(vO221.ail) + game.eePAPOrder.indexOf(vO221.ain) + 1;
          }
          var v7810 = game.map.manager.addAI(v7808.x, v7808.y, v7808.z, vO221.r, vO221.s[0] / 2, vO221.s[1] / 2, vO221.s[2] / 2, vO221, game.triggers, true);
          game.zSpawned++;
          game.AI.spawn(null, 0, vO221.ain, v7810.x, v7810.y, v7810.z, v7810.data);
          v7805.zLeft--;
        }
      }
    }
  },
  custUI: function () {
    window.switchLeaderboard(true, true);
  }
};